import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-006f039a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（貸借対照表）  出力", -1))
const _hoisted_2 = {
  id: "taishaku-taisho-form",
  class: "border border-primary p-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "登録", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "再集計", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "出力", -1))
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "row align-items-center mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto col-form-label" }, "法人名", -1))
const _hoisted_12 = { class: "col-auto" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "col-auto col-form-label",
  style: {"margin-left":"220px"}
}, "医療法人整理番号", -1))
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = { class: "row align-items-center mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto col-form-label" }, "所在地", -1))
const _hoisted_17 = { class: "col-auto" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "col-auto text-center mt-2 mb-1",
  style: {"font-size":"40px"}
}, "貸  借  対  照  表", -1))
const _hoisted_19 = {
  class: "row justify-content-center mt-0",
  style: {"margin-top":"0"}
}
const _hoisted_20 = { class: "col-auto" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto col-form-label" }, "現在", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-right mb-0" }, "（単位：千円）", -1))
const _hoisted_23 = { class: "m-1 d-flex" }
const _hoisted_24 = { style: {"width":"50%"} }
const _hoisted_25 = {
  class: "d-flex flex-column",
  style: {"width":"50%"}
}
const _hoisted_26 = {
  class: "table table-bordered",
  style: {"margin-top":"-1px"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "負債・純資産合計", -1))
const _hoisted_29 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_taishaku_taisho_export_report_shisan = _resolveComponent("taishaku-taisho-export-report-shisan")!
  const _component_taishaku_taisho_export_report_fusai = _resolveComponent("taishaku-taisho-export-report-fusai")!
  const _component_taishaku_taisho_export_report_junshisan = _resolveComponent("taishaku-taisho-export-report-junshisan")!
  const _component_input_kin = _resolveComponent("input-kin")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedRegister,
          loading: _ctx.loading,
          disabled: _ctx.hasError,
          class: "mr-2"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedRecalculate,
          loading: _ctx.loading,
          disabled: _ctx.hasError,
          class: "mr-5"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedExport,
          loading: _ctx.loading,
          disabled: _ctx.hasError
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm align-middle",
                style: {"width":"400px","resize":"none"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.corporationName) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.corporationName]
              ])
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm align-middle text-center",
                style: {"width":"120px","resize":"none"},
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.medicalCorporationNumber) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.medicalCorporationNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm align-middle",
                style: {"width":"600px","resize":"none"},
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.location) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.location]
              ])
            ])
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm text-center",
                style: {"width":"120px","resize":"none"},
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountingEndDate) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.accountingEndDate]
              ])
            ]),
            _hoisted_21
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_taishaku_taisho_export_report_shisan, {
                corporationType: _ctx.corporationType,
                ryudoShisanItems: _ctx.ryudoShisanItems,
                yukeiKoteiShisanItems: _ctx.yukeiKoteiShisanItems,
                mukeiKoteiShisanItems: _ctx.mukeiKoteiShisanItems,
                otherShisanItems: _ctx.otherShisanItems,
                shisanGokei: _ctx.shisanGokei,
                koteiShisanGokei: _ctx.koteiShisanGokei,
                isDisabledByCorporationType: _ctx.isDisabledByCorporationType,
                onUpdateKoteiShisanGokei: _cache[4] || (_cache[4] = (val) => _ctx.koteiShisanGokei.kin = val),
                onUpdateShisanGokei: _cache[5] || (_cache[5] = (val) => _ctx.shisanGokei.kin = val)
              }, null, 8, ["corporationType", "ryudoShisanItems", "yukeiKoteiShisanItems", "mukeiKoteiShisanItems", "otherShisanItems", "shisanGokei", "koteiShisanGokei", "isDisabledByCorporationType"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_taishaku_taisho_export_report_fusai, {
                corporationType: _ctx.corporationType,
                ryudoFusaiItems: _ctx.ryudoFusaiItems,
                koteiFusaiItems: _ctx.koteiFusaiItems,
                fusaiGokei: _ctx.fusaiGokei,
                isDisabledByCorporationType: _ctx.isDisabledByCorporationType,
                onUpdateFusaiGokei: _cache[6] || (_cache[6] = (val) => _ctx.fusaiGokei.kin = val)
              }, null, 8, ["corporationType", "ryudoFusaiItems", "koteiFusaiItems", "fusaiGokei", "isDisabledByCorporationType"]),
              _createVNode(_component_taishaku_taisho_export_report_junshisan, {
                corporationType: _ctx.corporationType,
                shushikin: _ctx.shushikin,
                kikin: _ctx.kikin,
                outputFundType: _ctx.outputFundType,
                tsumitateKinItems: _ctx.tsumitateKinItems,
                hyokaSagakuItems: _ctx.hyokaSagakuItems,
                junshisanGokei: _ctx.junshisanGokei,
                fusaiGokei: _ctx.fusaiGokei,
                isDisabledByCorporationType: _ctx.isDisabledByCorporationType,
                onUpdateJunshisanGokei: _cache[7] || (_cache[7] = (val) => _ctx.junshisanGokei.kin = val),
                onUpdateShushikin: _cache[8] || (_cache[8] = (val) => _ctx.shushikin.kin = val),
                onUpdateKikin: _cache[9] || (_cache[9] = (val) => _ctx.kikin.kin = val)
              }, null, 8, ["corporationType", "shushikin", "kikin", "outputFundType", "tsumitateKinItems", "hyokaSagakuItems", "junshisanGokei", "fusaiGokei", "isDisabledByCorporationType"]),
              _createElementVNode("table", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_28,
                    _createElementVNode("td", _hoisted_29, [
                      _createVNode(_component_input_kin, {
                        modelValue: _ctx.fusaiJunshisanGokei.kin,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fusaiJunshisanGokei.kin) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}